import {$post, $get} from '../utils/request'

export const $statisticsList=async(params)=>{
    console.log("查询统计信息开始")
    console.log(params)
    let res=await $post('statisticsList.do',params);
    return res;
}
